(function(konto) {
	konto.ba = {};
} (konto = window.konto));